const setFirstTimeTrue = () => ({
  type: "FIRST_TIME_TRUE",
  payload: true,
});

const setFirstTimeFalse = () => ({
  type: "FIRST_TIME_FALSE",
  payload: false,
});

export const setFirstTimeToPage = (isFirstTime) => (dispatch) => {
  if (isFirstTime) {
    dispatch(setFirstTimeTrue());
  } else {
    dispatch(setFirstTimeFalse());
  }
};

export const setCustomerDetails = (data) => ({
  type: "SET_CUSTOMER_DETAILS",
  payload: data,
});

export const setInputUserID = (data) => ({
  type: "SET_INP_USER_ID",
  payload: data,
});

export const setIsLoggedInUser = (data) => ({
  type: "SET_IS_LOGGED_IN_USER",
  payload: data,
});
